interface ILocalBucket {
    exp829_disableTopAnnouncementBar: boolean,
    exp829_disableToyboxIntegration: boolean,
    exp830_enableReactMasthead: boolean,
    bearTileBg: boolean,
    [key: string]: boolean
}

const bucket: ILocalBucket = {
    /** This switch disables the announcement bar. */
    exp829_disableTopAnnouncementBar: true,
    /** This switch disable the Toybox integration. */
    exp829_disableToyboxIntegration: true,
    /** This enables the React-powered Masthead, */
    exp830_enableReactMasthead: true,
    /** This enables the bear tile background. */
    bearTileBg: false
};

export default bucket